import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { DocumentDetail } from '../models/documentVersionDetail';
import { DocumentService } from '../services/document.service';
import { LabelConstants } from '../../shared/constants/label-constants';
import { SmartLinksResponse } from '../models/smart-link-model';

@Component({
    selector: 'app-document-link',
    templateUrl: './document-link.component.html',
    styleUrls: ['./document-link.component.scss']
})
export class DocumentLinkComponent implements OnInit, OnDestroy {
    @Output() isShowDocumentLinkModal = new EventEmitter<boolean>();
    @Input() documentDetail!: DocumentDetail;
    @Input() isDocumentLinkModalOpen!: boolean;

    effectiveDocumentVersionLink!: string;
    effectiveDocumentVersionSmartLink!: string;
    specificDocumentVersionLink!: string;
    latestDocumentVersionLink!: string;
    isDocumentEffective!: string;
    display: boolean = true;

    latestVersionLink: string = LabelConstants.LatestVersionLink;
    specificVersionLink: string = LabelConstants.SpecificVersionLink;
    effectiveVersionLink: string = LabelConstants.EffectiveVersionLink;
    effectiveVersionLinkDisplay!: boolean;

    isLoadingSmartLinks = false;

    private readonly destroy$ = new Subject<void>();

    constructor(
        private documentService: DocumentService
    ) { }

    ngOnInit(): void {
        this.buildPageLinks();
        this.loadSmartLinks();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private buildPageLinks(): void {
        if (this.documentDetail.isEffectiveVersionAvailable) {
            this.effectiveVersionLinkDisplay = true;
            this.effectiveDocumentVersionLink = location.origin.concat(
                '/eqms.documentDetails/', this.documentDetail.number
            );
        }
        this.latestDocumentVersionLink = location.origin.concat(
            '/eqms.documentDetails/', this.documentDetail.number, ':latest'
        );
        this.specificDocumentVersionLink = location.origin.concat(
            '/eqms.documentDetails/', this.documentDetail.number, ':', this.documentDetail.version
        );
    }

    private loadSmartLinks(): void {
        this.isLoadingSmartLinks = true;
        this.documentService.getSmartLinks(this.documentDetail.number)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response: SmartLinksResponse) => {
                    this.effectiveDocumentVersionSmartLink =
                        response?.smartLink ?? '';
                    this.isLoadingSmartLinks = false;
                },
                error: () => {
                    this.isLoadingSmartLinks = false;
                }
            });
    }

    closeModal(): void {
        this.isDocumentLinkModalOpen = false;
        this.isShowDocumentLinkModal.emit(this.isDocumentLinkModalOpen);
    }
}
